import { render, staticRenderFns } from "./AppGameControl.vue?vue&type=template&id=0fc4e90d&scoped=true&"
import script from "./AppGameControl.vue?vue&type=script&lang=js&"
export * from "./AppGameControl.vue?vue&type=script&lang=js&"
import style0 from "./AppGameControl.vue?vue&type=style&index=0&id=0fc4e90d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc4e90d",
  null
  
)

export default component.exports